(function() {
  function formatMoney(cents, format) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, format);
    }
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var formatString = format || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) {
      return String(cents / 100);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function getVariantOptionValue(variant, index) {
    if (!variant) return null;
    if (variant.options && variant.options[index]) return variant.options[index];
    if (index === 0) return variant.option1;
    if (index === 1) return variant.option2;
    if (index === 2) return variant.option3;
    return null;
  }

  function variantMatchesOptions(variant, selectedOptions) {
    var keys = Object.keys(selectedOptions);
    for (var k = 0; k < keys.length; k++) {
      var i = parseInt(keys[k], 10);
      if (getVariantOptionValue(variant, i) !== selectedOptions[i]) return false;
    }
    return true;
  }

  function findVariant(product, selectedOptions) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (!product.options || !product.options.length) return product.variants[0];
    return product.variants.find(function(v) {
      return variantMatchesOptions(v, selectedOptions);
    }) || null;
  }

  function getProductMedia(product) {
    if (!product) return [];
    if (product.media && product.media.length) return product.media;
    if (product.variants && product.variants.length) {
      for (var i = 0; i < product.variants.length; i++) {
        var img = product.variants[i].featured_image;
        if (img && img.src) {
          return [{ id: img.id, src: img.src, aspectRatio: img.aspect_ratio || 1 }];
        }
      }
    }
    return [];
  }

  var setPswpLoadPromise = null;
  var setPswpInstance = null;

  function loadSetPhotoSwipe() {
    if (window.ThemePhotoSwipe) return Promise.resolve();
    if (setPswpLoadPromise) return setPswpLoadPromise;

    setPswpLoadPromise = new Promise(function(resolve, reject) {
      var src = window.themeVariables && window.themeVariables.libs && window.themeVariables.libs.photoswipe;
      if (!src) {
        reject(new Error('PhotoSwipe unavailable'));
        return;
      }

      if (document.getElementById('photoswipe')) {
        var attempts = 0;
        var timer = setInterval(function() {
          attempts++;
          if (window.ThemePhotoSwipe) {
            clearInterval(timer);
            resolve();
          } else if (attempts > 100) {
            clearInterval(timer);
            reject(new Error('PhotoSwipe load timeout'));
          }
        }, 50);
        return;
      }

      var script = document.createElement('script');
      script.id = 'photoswipe';
      script.src = src;
      script.async = true;
      script.onload = function() { resolve(); };
      script.onerror = function() { reject(new Error('PhotoSwipe load failed')); };
      document.head.appendChild(script);
    });

    return setPswpLoadPromise;
  }

  function SetPhotoSwipeUi(pswp) {
    this.photoSwipeInstance = pswp;
    this.pswpUi = pswp.scrollWrap.querySelector('.pswp__ui');
    this._onClick = function(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      if (action === 'pswp-close') pswp.close();
      if (action === 'pswp-prev') pswp.prev();
      if (action === 'pswp-next') pswp.next();
    };
    pswp.scrollWrap.addEventListener('click', this._onClick);
    pswp.listen('initialZoomInEnd', function() {
      if (this.pswpUi) this.pswpUi.classList.remove('pswp__ui--hidden');
    }.bind(this));
    pswp.listen('close', function() {
      pswp.scrollWrap.removeEventListener('click', this._onClick);
    }.bind(this));
  }

  SetPhotoSwipeUi.prototype.init = function() {
    var pswp = this.photoSwipeInstance;
    var prevNext = this.pswpUi && this.pswpUi.querySelector('.pswp__prev-next-buttons');
    var dots = this.pswpUi && this.pswpUi.querySelector('.pswp__dots-nav-wrapper');
    var showNav = pswp.items.length > 1;
    if (prevNext) prevNext.style.display = showNav ? '' : 'none';
    if (dots) dots.style.display = showNav ? '' : 'none';
  };

  SetPhotoSwipeUi.prototype.destroy = function() {};

  function openSetPhotoSwipe(pswpEl, media, startIndex, thumbImg) {
    return loadSetPhotoSwipe().then(function() {
      if (setPswpInstance) {
        try { setPswpInstance.close(); } catch (err) {}
        setPswpInstance = null;
      }

      var maxSpreadZoom = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.mobileZoomFactor) || 2;
      var desiredWidth = Math.min(window.innerWidth * (window.devicePixelRatio || 1), 3000);
      var items = media.map(function(item, i) {
        var w = Math.min(desiredWidth, 3000);
        var ratio = item.aspectRatio || 1;
        return {
          src: item.src,
          msrc: item.src,
          w: w,
          h: Math.round(w / ratio),
          selected: i === startIndex
        };
      });

      setPswpInstance = new window.ThemePhotoSwipe(pswpEl, SetPhotoSwipeUi, items, {
        index: startIndex,
        maxSpreadZoom: maxSpreadZoom,
        loop: false,
        allowPanToNext: items.length > 1,
        closeOnScroll: false,
        closeOnVerticalDrag: window.matchMedia('(hover: hover)').matches,
        showHideOpacity: true,
        arrowKeys: true,
        history: false,
        getThumbBoundsFn: function() {
          if (!thumbImg) return { x: 0, y: 0, w: 0 };
          var rect = thumbImg.getBoundingClientRect();
          var scrollY = window.pageYOffset || document.documentElement.scrollTop;
          return { x: rect.left, y: rect.top + scrollY, w: rect.width };
        },
        getDoubleTapZoom: function(isMouseClick, item) {
          if (isMouseClick) {
            return item.w > item.h ? 1.6 : 1;
          }
          return item.initialZoomLevel < 0.7 ? 1 : 1.33;
        }
      });

      setPswpInstance.listen('close', function() {
        setPswpInstance = null;
      });
      setPswpInstance.init();
    }).catch(function() {});
  }

  function initGallery(galleryEl, state, zoomOptions) {
    if (!galleryEl) return;
    var track = galleryEl.querySelector('[data-gallery-track]');
    var progressEl = galleryEl.querySelector('[data-gallery-progress]');
    var progressThumb = galleryEl.querySelector('[data-gallery-progress-thumb]');
    var prevBtn = galleryEl.querySelector('[data-gallery-prev]');
    var nextBtn = galleryEl.querySelector('[data-gallery-next]');
    if (!track || !prevBtn || !nextBtn) return;
    var index = 0;
    var zoomBtn = galleryEl.querySelector('[data-set-zoom-btn]');
    var enableZoom = zoomOptions && zoomOptions.enabled && zoomOptions.pswpEl;
    var mobileQuery = window.matchMedia('(max-width: 999px)');
    var scrollRaf = null;

    function isMobileGallery() {
      return mobileQuery.matches;
    }

    function openZoom() {
      if (!enableZoom) return;
      var media = state.media || [];
      if (!media.length) return;
      var thumbImg = galleryEl.querySelector('.wd-product-set__gallery-slide.is-active img');
      openSetPhotoSwipe(zoomOptions.pswpEl, media, index, thumbImg);
    }

    function syncActiveSlide() {
      var slides = track.querySelectorAll('.wd-product-set__gallery-slide');
      slides.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= slides.length - 1;
    }

    function updateProgress() {
      if (!progressEl || !progressThumb) return;
      var sl = Math.abs(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      var trackW = progressEl.clientWidth;
      var thumbW = maxScroll > 0 ? (track.clientWidth / track.scrollWidth) * trackW : trackW;
      var thumbX = maxScroll > 0 ? (1 - sl / maxScroll) * (trackW - thumbW) : 0;
      progressThumb.style.setProperty('--thumb-w', thumbW + 'px');
      progressThumb.style.setProperty('--thumb-x', thumbX + 'px');
    }

    function renderProgress(media) {
      if (!progressEl) return;
      if (!isMobileGallery() || media.length <= 1) {
        progressEl.setAttribute('hidden', '');
        return;
      }
      progressEl.removeAttribute('hidden');
      updateProgress();
    }

    function scrollToIndex(behavior) {
      if (!isMobileGallery()) return;
      var slide = track.querySelector('.wd-product-set__gallery-slide');
      if (!slide) return;
      track.scrollTo({ left: index * slide.offsetWidth, behavior: behavior || 'auto' });
    }

    function syncIndexFromScroll() {
      if (!isMobileGallery()) return;
      var slides = track.querySelectorAll('.wd-product-set__gallery-slide');
      if (!slides.length) return;

      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var bestIndex = 0;
      var bestDistance = Infinity;

      slides.forEach(function(slide, i) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(slideCenter - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = i;
        }
      });

      if (bestIndex !== index) {
        index = bestIndex;
        syncActiveSlide();
      }
    }

    function onTrackScroll() {
      if (!isMobileGallery()) return;
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function() {
        syncIndexFromScroll();
        updateProgress();
      });
    }

    function render() {
      var media = state.media || [];
      if (!media.length) {
        galleryEl.setAttribute('hidden', '');
        track.innerHTML = '';
        if (progressEl) progressEl.setAttribute('hidden', '');
        if (zoomBtn) zoomBtn.hidden = true;
        return;
      }

      galleryEl.removeAttribute('hidden');

      track.innerHTML = media.map(function(item, i) {
        return '<div class="wd-product-set__gallery-slide' + (i === index ? ' is-active' : '') + '">' +
          '<img src="' + item.src + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '"' + (enableZoom ? ' class="wd-product-set__zoomable"' : '') + '>' +
        '</div>';
      }).join('');

      if (zoomBtn) zoomBtn.hidden = !enableZoom;

      renderProgress(media);
      syncActiveSlide();
      scrollToIndex('auto');
    }

    if (enableZoom && !galleryEl.dataset.zoomBound) {
      galleryEl.dataset.zoomBound = 'true';
      track.addEventListener('click', function(e) {
        if (e.target.matches('.wd-product-set__zoomable')) openZoom();
      });
      if (zoomBtn) zoomBtn.addEventListener('click', openZoom);
    }

    if (!galleryEl.dataset.scrollBound) {
      galleryEl.dataset.scrollBound = 'true';
      track.addEventListener('scroll', onTrackScroll, { passive: true });
      var onBreakpointChange = function() {
        index = 0;
        render();
      };
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', onBreakpointChange);
      } else {
        mobileQuery.addListener(onBreakpointChange);
      }
    }

    prevBtn.addEventListener('click', function() {
      if (index > 0) {
        index--;
        if (isMobileGallery()) {
          syncActiveSlide();
          scrollToIndex('smooth');
        } else {
          render();
        }
      }
    });
    nextBtn.addEventListener('click', function() {
      if (index < (state.media || []).length - 1) {
        index++;
        if (isMobileGallery()) {
          syncActiveSlide();
          scrollToIndex('smooth');
        } else {
          render();
        }
      }
    });

    state.onMediaChange = function(newMedia) {
      state.media = newMedia || [];
      index = 0;
      render();
    };

    render();
  }

  function initPart(root, partKey, config, galleries, updatePrice) {
    var partEl = root.querySelector('[data-set-part="' + partKey + '"]');
    if (!partEl) return { findVariant: function() { return null; } };

    var products = (config.parts[partKey] && config.parts[partKey].products) || [];
    var colorBtns = partEl.querySelectorAll('.variant-swatch__item[data-product-index]');
    var sizeOptionEl = partEl.querySelector('[data-size-option]');
    var sizeListEl = partEl.querySelector('[data-size-list]');
    var sizeLabelEl = partEl.querySelector('[data-size-label]');
    var colorValueEl = partEl.querySelector('[data-part-color-value]');
    var skuEl = partEl.querySelector('[data-part-sku]');
    var skuNumberEl = partEl.querySelector('[data-part-sku-number]');
    var gallery = galleries[partKey] || { onMediaChange: function() {} };

    var state = {
      productIndex: 0,
      selectedOptions: {},
      sizeOptionIndex: -1,
      media: []
    };

    function currentProduct() {
      return products[state.productIndex] || null;
    }

    function getUniqueSizes(product) {
      var idx = typeof product.sizeOptionIndex === 'number' ? product.sizeOptionIndex : -1;
      state.sizeOptionIndex = idx;
      if (idx === -1) return [];
      var seen = {};
      var sizes = [];
      (product.variants || []).forEach(function(v) {
        var val = getVariantOptionValue(v, idx);
        if (val && val !== 'Default Title' && !seen[val]) {
          seen[val] = true;
          sizes.push(val);
        }
      });
      return sizes;
    }

    function updateSizeButtons() {
      var product = currentProduct();
      if (!product) {
        sizeOptionEl.hidden = true;
        return;
      }

      var sizes = getUniqueSizes(product);
      if (!sizes.length) {
        sizeOptionEl.hidden = true;
        state.selectedOptions = {};
        return;
      }

      if (!sizeOptionEl || !sizeListEl) return;

      sizeOptionEl.hidden = false;
      sizeOptionEl.removeAttribute('hidden');
      sizeListEl.innerHTML = '';
      sizes.forEach(function(size) {
        var hasAvailable = (product.variants || []).some(function(v) {
          return v.available && getVariantOptionValue(v, state.sizeOptionIndex) === size;
        });
        var isSelected = state.selectedOptions[state.sizeOptionIndex] === size;
        var wrap = document.createElement('div');
        wrap.className = 'block-swatch' + (!hasAvailable ? ' is-disabled' : '');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'block-swatch__item' + (isSelected ? ' is-selected' : '');
        btn.setAttribute('data-size-value', size);
        btn.textContent = size;
        wrap.appendChild(btn);
        sizeListEl.appendChild(wrap);
      });

      sizeListEl.querySelectorAll('[data-size-value]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.closest('.block-swatch') && btn.closest('.block-swatch').classList.contains('is-disabled')) return;
          state.selectedOptions[state.sizeOptionIndex] = btn.dataset.sizeValue;
          if (sizeLabelEl) sizeLabelEl.textContent = btn.dataset.sizeValue;
          sizeListEl.querySelectorAll('.block-swatch__item').forEach(function(b) {
            b.classList.toggle('is-selected', b === btn);
          });
          updateAvailability();
          updateSku();
          if (updatePrice) updatePrice();
        });
      });

      if (!state.selectedOptions[state.sizeOptionIndex]) {
        var firstAvailable = sizes.find(function(size) {
          return (product.variants || []).some(function(v) {
            return v.available && getVariantOptionValue(v, state.sizeOptionIndex) === size;
          });
        });
        if (firstAvailable) {
          state.selectedOptions[state.sizeOptionIndex] = firstAvailable;
          if (sizeLabelEl) sizeLabelEl.textContent = firstAvailable;
          sizeListEl.querySelectorAll('.block-swatch__item').forEach(function(b) {
            b.classList.toggle('is-selected', b.dataset.sizeValue === firstAvailable);
          });
        }
      }
    }

    function updateAvailability() {
      if (!colorBtns.length) return;
      colorBtns.forEach(function(btn, i) {
        var wrap = btn.closest('.variant-swatch');
        if (wrap) wrap.classList.toggle('is-disabled', !products[i] || !products[i].available);
      });
    }

    function resolveVariant() {
      var product = currentProduct();
      if (!product) return null;
      var idx = state.sizeOptionIndex;
      if (idx === -1) {
        return (product.variants && product.variants[0]) || null;
      }
      if (state.selectedOptions[idx] === undefined) return null;
      return findVariant(product, state.selectedOptions);
    }

    function updateSku() {
      if (!skuEl || !skuNumberEl) return;
      var variant = resolveVariant();
      if (variant && variant.sku) {
        skuNumberEl.textContent = variant.sku;
        skuEl.hidden = false;
      } else {
        skuNumberEl.textContent = '';
        skuEl.hidden = true;
      }
    }

    function selectProduct(index) {
      if (!products[index]) return;
      state.productIndex = index;
      state.selectedOptions = {};
      var product = products[index];
      colorBtns.forEach(function(btn, i) {
        btn.classList.toggle('is-selected', i === index);
        btn.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      if (colorValueEl && product.title) {
        var titleParts = product.title.split(/\s*[-–—]\s*/);
        colorValueEl.textContent = titleParts[titleParts.length - 1].trim();
      }
      updateSizeButtons();
      gallery.onMediaChange(getProductMedia(product));
      updateAvailability();
      updateSku();
      if (updatePrice) updatePrice();
    }

    colorBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.closest('.variant-swatch') && btn.closest('.variant-swatch').classList.contains('is-disabled')) return;
        selectProduct(parseInt(btn.dataset.productIndex, 10));
      });
    });

    var firstAvailableIndex = products.findIndex(function(p) { return p.available; });
    selectProduct(firstAvailableIndex >= 0 ? firstAvailableIndex : 0);

    return {
      findVariant: resolveVariant
    };
  }

  function bootSetPages() {
  document.querySelectorAll('wd-product-set').forEach(function(root) {
    if (root.getAttribute('data-wd-set-initialized') === 'true') return;

    try {
    var configEl = root.querySelector('[data-set-config]');
    if (!configEl) return;

    var config = JSON.parse(configEl.textContent);
    var priceEl = root.querySelector('[data-set-price]');
    var atcBtn = root.querySelector('[data-set-atc]');
    var qtyInput = root.querySelector('[data-set-qty]');
    var validationSelect = root.querySelector('[data-validation-select]');
    var validationSoldout = root.querySelector('[data-validation-soldout]');
    if (!atcBtn) return;

    var atcDefaultText = atcBtn.textContent;
    var partKeys = Object.keys(config.parts || {});
    var parts = {};

    root._wdSetUpdatePrice = function() {
      if (!priceEl || !partKeys.length) return;
      var variants = partKeys.map(function(key) {
        return parts[key] ? parts[key].findVariant() : null;
      });
      if (variants.some(function(v) { return !v; })) {
        priceEl.innerHTML = '<span class="price price--large">—</span>';
        return;
      }

      var totalPrice = 0;
      var totalCompare = 0;
      variants.forEach(function(v) {
        totalPrice += v.price;
        totalCompare += v.compare_at_price || 0;
      });
      var html = '';

      if (totalCompare > totalPrice) {
        html += '<span class="price price--highlight price--large">' + formatMoney(totalPrice, config.moneyFormat) + '</span>';
        html += '<span class="price price--compare">' + formatMoney(totalCompare, config.moneyFormat) + '</span>';
      } else {
        html += '<span class="price price--large">' + formatMoney(totalPrice, config.moneyFormat) + '</span>';
      }
      priceEl.innerHTML = html;
    };

    var galleries = {};
    var zoomOptions = {
      enabled: !!config.enableImageZoom,
      pswpEl: config.enableImageZoom ? root.querySelector('[data-set-pswp]') : null
    };
    root.querySelectorAll('[data-gallery]').forEach(function(galleryEl) {
      var key = galleryEl.getAttribute('data-gallery');
      galleries[key] = { media: [] };
      initGallery(galleryEl, galleries[key], zoomOptions);
    });

    partKeys.forEach(function(key) {
      parts[key] = initPart(root, key, config, galleries, root._wdSetUpdatePrice);
    });
    root._wdSetUpdatePrice();

    atcBtn.addEventListener('click', function() {
      validationSelect.classList.remove('is-visible');
      validationSoldout.classList.remove('is-visible');

      var variants = partKeys.map(function(key) {
        return parts[key] ? parts[key].findVariant() : null;
      });

      if (variants.some(function(v) { return !v; })) {
        validationSelect.classList.add('is-visible');
        return;
      }
      if (variants.some(function(v) { return !v.available; })) {
        validationSoldout.classList.add('is-visible');
        return;
      }

      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      if (qty < 1) qty = 1;
      atcBtn.disabled = true;

      var controller = new AbortController();
      var timeoutId = setTimeout(function() { controller.abort(); }, 10000);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          items: variants.map(function(v) {
            return { id: v.id, quantity: qty };
          })
        })
      })
      .then(function(res) {
        clearTimeout(timeoutId);
        if (!res.ok) return res.json().then(function(e) { throw e; });
        return res.json();
      })
      .then(function() {
        var cartController = new AbortController();
        var cartTimeoutId = setTimeout(function() { cartController.abort(); }, 10000);
        return fetch('/cart.js', { signal: cartController.signal }).then(function(r) {
          clearTimeout(cartTimeoutId);
          if (!r.ok) throw new Error('cart fetch failed');
          return r.json();
        });
      })
      .then(function(cart) {
        atcBtn.classList.add('is-success');
        atcBtn.textContent = config.addedToCart || atcDefaultText;
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
        setTimeout(function() {
          atcBtn.classList.remove('is-success');
          atcBtn.disabled = false;
          atcBtn.textContent = atcDefaultText;
        }, 2000);
      })
      .catch(function() {
        clearTimeout(timeoutId);
        atcBtn.disabled = false;
        atcBtn.textContent = config.addToCartError || atcDefaultText;
        setTimeout(function() {
          atcBtn.textContent = atcDefaultText;
        }, 3000);
      });
    });

    root.setAttribute('data-wd-set-initialized', 'true');
    } catch (err) {
      if (typeof console !== 'undefined' && console.error) {
        console.error('wd-product-set init failed', err);
      }
    }
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSetPages);
  } else {
    bootSetPages();
  }
})();
